/* eslint-disable */
import { Component, Vue } from "vue-property-decorator";
import { ProductSector, ProductCategory, ProductClass } from "@/models";

interface TaxonomyData {
  id: string;
  type: string;
}

interface TaxonomyValue {
  sector: string | string[];
  category: string | string[];
  class: string | string[];
}

@Component
export default class TaxonomyMixin extends Vue {
  mapTaxonomies(taxonomies: TaxonomyValue): {
    id: string;
    type: string;
  }[] {
    const sectors = this.mapTaxonomyItem(taxonomies.sector, "productSectors");
    const categories = this.mapTaxonomyItem(
      taxonomies.category,
      "productCategories"
    );
    const classes = this.mapTaxonomyItem(taxonomies.class, "productClasses");

    return [...sectors, ...categories, ...classes];
  }

  mapTaxonomyItem(
    element: string | string[] | undefined,
    type: string
  ): TaxonomyData[] {
    if (Array.isArray(element)) {
      return (element as []).map((id: string) => {
        return { id: id, type };
      });
    } else if (typeof element === "string") {
      return [{ id: element, type }];
    }
    return [];
  }

  mapTaxonomyValue(
    taxonomies: Array<ProductSector | ProductCategory | ProductClass>
  ): TaxonomyValue {
    const values: TaxonomyValue = {
      sector: [],
      category: [],
      class: [],
    };

    taxonomies.forEach((taxonomy) => {
      if (taxonomy instanceof ProductSector) {
        (values.sector as string[]).push(taxonomy.id);
      }

      if (taxonomy instanceof ProductCategory) {
        (values.category as string[]).push(taxonomy.id);
      }

      if (taxonomy instanceof ProductClass) {
        (values.class as string[]).push(taxonomy.id);
      }
    });

    return values;
  }
}
